@if (_currentData.currentAction === 'LIST' || _currentData.currentAction === 'VIEW_DETAILS') {
  <dhs-data-grid
    [fields]="_currentData.currentListFields" [cardHeaders]="_currentData.cardHeader"
    [filterFieldGroup]="_currentData.currentFilterListFormFields" [data]="_currentData.dataList"
    [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick"
    (configValues)="getConfigValues($event)" (bulkActionClicked)="onBulkActionClicked($event)"
    (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)" (onFilterChange)="filterChange($event)"
    (editEllipseClick)="buttonAction($event)" (onPageChanges)="pageChanges($event)"
    (onSortChanges)="sortChanges($event);" [config]="_currentData.dataGridConfig">
  </dhs-data-grid>
}